import React, { Component } from "react";
import {
  View,
  Image,
  TouchableOpacity,
  FlatList,
  Dimensions,
} from "react-native";
import { icons } from "../theme/icons";
import { appStyles, componentStyles } from "../theme/styles";
import TextView from "../components/TextView";
import { hp, wp } from "../utils/responsive";
import {
  blueDarkColor,
  blueLightColor,
  greenDarkColor,
  greenLightColor,
} from "../theme/colors";
import LinearGradient from "react-native-linear-gradient";
import { getActiveInsurances, orderSelectInsurance } from "../utils/api";
import { persianNumber, showPrompt } from "../utils/utils";

export default class InsuranceListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      search: "",
      parts: [],
      selected: "",
    };
  }
  _keyExtractor = (item, index) => index.toString();
  renderRow({ item, index }) {
    console.log({ item });
    return (
      <TouchableOpacity
        onPress={() => {
          orderSelectInsurance(item.id, (isConnect, response) => {
            if (response.isSuccess) {
              this.setState({ selected: item.id });
              // this.props.navigation.navigate('services');
              //       id: item.id,
              //       title: item.title,
              //     });
            }
          });
        }}
        style={[
          this.state.selected === item.id
            ? componentStyles.selectedService
            : null,
          appStyles.shadow,
          { backgroundColor: "white" },
        ]}
      >
        <LinearGradient
          colors={
            this.state.selected === item.id
              ? [greenLightColor, greenDarkColor]
              : [blueLightColor, blueDarkColor]
          }
          style={[componentStyles.serviceInfoItemWraper]}
        >
          <Image
            source={{ uri: item.imagename }}
            resizeMode={"contain"}
            // tintColor="white"
            style={componentStyles.serviceImage}
          />
          <TextView
            numberOfLines={2}
            style={{
              fontSize: 12,
              color: "white",
              textAlign: "center",
              margin: 5,
            }}
          >
            {item.name}
          </TextView>
        </LinearGradient>
      </TouchableOpacity>
    );
  }

  componentWillMount() {
    getActiveInsurances((isConnect, response) => {
      this.setState({
        data: response.data,
      });
    });
  }
  render() {
    return (
      <View style={appStyles.flex1}>
        <View style={appStyles.toolbarWraper}>
          <Image
            source={icons["ad"]}
            style={[appStyles.toolbarIcon, { tintColor: "#31BFCF" }]}
          />
          <TextView style={appStyles.toolbarTitle}>انتخاب بیمه</TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.goBack();
            }}
          >
            <Image source={icons["back"]} style={appStyles.backIcon} />
          </TouchableOpacity>
        </View>

        <FlatList
          data={this.state.data}
          // key={index}
          contentContainerStyle={{ justifyContent: "space-around" }}
          keyExtractor={this._keyExtractor}
          numColumns={3}
          renderItem={this.renderRow.bind(this)}
        />

        <View
          style={[
            appStyles.bottomView,
            appStyles.center,
            appStyles.shadow,
            { minHeight: 100, backgroundColor: "white", marginTop: 5 },
          ]}
        >
          <TouchableOpacity
            activeOpacity={0.5}
            onPress={() => {
              if (this.state.selected) {
                this.props.navigation.navigate("services");
              } else {
                showPrompt(
                  "انتخاب بیمه",
                  "آیا بدون بیمه ادامه می دهید؟",
                  () => {
                    this.props.navigation.navigate("services");
                  }
                );
              }
            }}
          >
            <LinearGradient
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={
                this.state.selected
                  ? [greenLightColor, greenDarkColor]
                  : [blueLightColor, blueDarkColor]
              }
              style={[
                componentStyles.gradinatButton,
                {
                  width: wp(90),
                  borderRadius: 25,
                  height: 50,
                },
              ]}
            >
              <TextView isbold={true} style={componentStyles.requestText}>
                درخواست خدمات
              </TextView>
            </LinearGradient>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}
